export class Colors {
	static contrastingColor(color: string) {
		return Colors.luma(color) >= 165 ? '#000' : '#fff'
	}
	static luma(color: string) {
		// color can be a hx string or an array of RGB values 0-255
		var rgb = typeof color === 'string' ? Colors.hexToRGBArray(color.replace('#', '')) : color
		return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2] // SMPTE C, Rec. 709 weightings
	}
	static hexToRGBArray(color: string) {
		if (color.length === 3)
			color = color.charAt(0) + color.charAt(0) + color.charAt(1) + color.charAt(1) + color.charAt(2) + color.charAt(2)
		else if (color.length !== 6) throw new Error('Invalid hex color: ' + color)
		var rgb = []
		for (var i = 0; i <= 2; i++) rgb[i] = parseInt(color.substr(i * 2, 2), 16)
		return rgb
	}

	/**
	 * Recebe a core em hexadecimal e a porcentagem de ajuste a fazer
	 * @param color - Cor em hexadecimal
	 * @param percent - Porcentagem para clarear/escurecer (numero positivo para clarear e numero negativo para escurecer)
	 * @return string - Cor ajustada em hexadecimal
	 */
	static shadeColor(color: string, percent: number): string {
		if (!color || !percent) return '#000000'

		return (
			'#' +
			color
				.replace(/^#/, '')
				.replace(/../g, (color) => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + percent)).toString(16)).substr(-2))
		)
	}

	static primary = '#803fd2'
	//static primary: '#245825'

	static secondary = '#ECE2F8'
	//static secondary = '#cc3d99'
	static accent = '#82B1FF'
	static error = '#F26171'
	static info = '#2196F3'
	static success = '#0B5C11'
	static warning = '#FFF8E6'
	static opacity = '#E8F1E7'
	static surface = '#F5F5F7'

	static analysisBg = '#7B2661'
	static deniedBg = '#FBE3E3'
	static successBg = '#E3F3E4'

	static warningTextColor = '#503E01'
	static successTextColor = '#0b5c11'

	static notificationItemBackground = '#EDEDED'
}
